import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd8f037a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "completed" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    opacity: "0.8",
    cx: "26.5",
    cy: "26.5",
    r: "26.5",
    fill: "#76B13A"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.3531 33.0471L17.1372 26.8312L15.0205 28.933L23.3531 37.2656L41.2406 19.3781L39.1388 17.2763L23.3531 33.0471Z",
    fill: "white"
  })
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "ph"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Thank you. Your full payment of")
const _hoisted_10 = { class: "mx-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("has been received.")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Payment details and receipt will be sent to your email ")
const _hoisted_14 = {
  key: 3,
  class: "ph"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceSteps = _resolveComponent("InvoiceSteps")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_InvoiceSteps, {
      steps: _ctx.steps,
      currentStep: 5
    }, null, 8, ["steps"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.invoice)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_6, "Payment complete"))
              : (_openBlock(), _createElementBlock("h2", _hoisted_7)),
            (_ctx.invoice)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("b", _hoisted_10, _toDisplayString(_ctx.currency(_ctx.invoice.total_price, _ctx.invoice.currency, 2, true)), 1),
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _createElementVNode("b", null, _toDisplayString(_ctx.invoice.contact.email), 1)
                ]))
              : (_openBlock(), _createElementBlock("h3", _hoisted_14))
          ])
        ])
      ])
    ])
  ], 64))
}